export default "/images/notice.svg?0f512e7ecf023d1476fb93ad4258d738";